import { FormControlLabel, Radio } from '@mui/material';
import RadioEmptyIcon from 'assets/img/icons/RadioEmptyIcon';
import RadioFilledIcon from 'assets/img/icons/RadioFilledIcon';
import { DARKER_GREY } from 'utils/theme';

const RadioButton = ({ value, label }: { value: string; label: string }) => {
  return (
    <FormControlLabel
      value={value}
      control={
        <Radio sx={{ py: 0.5 }} icon={<RadioEmptyIcon />} checkedIcon={<RadioFilledIcon />} />
      }
      label={label}
      sx={{ color: DARKER_GREY }}
    />
  );
};

export default RadioButton;
